import Vue from "vue";
import Router from "vue-router";
import home from "./views/Home.vue";
import about from "./views/About.vue";
import contact from "./views/Contact.vue";
import process from "./views/Process.vue";
import mission from "./views/Mission.vue";
import authorization from "./views/Authorization.vue";

Vue.use(Router);

var langs = ["", "en", "ru", "ua"],
    siteComponents = [home, about, contact, process, mission, authorization],
    hashes = [
        "home",
        "approach",
        "scale",
        "brands",
        "marketing_support",
        "customer_service",
        "software_integration",
        "authorization",
    ],
    siteRoutes = new Array();

for (var r = 0; r < siteComponents.length; r++) {
    for (var l = 0; l < langs.length; l++) {
        var locale = langs[l] == "" ? "" : "/" + langs[l],
            nameDelimeter =
                locale == "" ? "" : (langs[l] == "" ? "" : langs[l]) + ".",
            route = {
                path:
                    r == 0
                        ? locale + "/"
                        : locale + "/" + siteComponents[r].ComponentName,
                name: nameDelimeter + siteComponents[r].ComponentName,
                component: siteComponents[r],
            };

        siteRoutes.push(route);
    }

    if (r == 0) {
        for (var h = 0; h < hashes.length; h++) {
            for (var l = 0; l < langs.length; l++) {
                var locale = langs[l] == "" ? "" : "/" + langs[l],
                    nameDelimeter =
                        locale == ""
                            ? ""
                            : (langs[l] == "" ? "" : langs[l]) + ".",
                    route = {
                        path:
                            r == 0
                                ? (locale == "" ? "/" : locale) +
                                  "#" +
                                  hashes[h]
                                : locale +
                                  "/" +
                                  siteComponents[r].ComponentName +
                                  "#" +
                                  hashes[h],
                        name:
                            nameDelimeter +
                            siteComponents[r].ComponentName +
                            "#" +
                            hashes[h],
                        component: siteComponents[r],
                    };

                siteRoutes.push(route);
            }
        }
    }
}

const router = new Router({
    mode: "history",
    base: __dirname,
    routes: siteRoutes,
});

export default router;
